export default "__VITE_ASSET__7ad298d9__"